module.exports = __webpack_public_path__ + "static/img/img_23.04fbd043.png";